import React, {useEffect, useRef, useState} from "react";
import ReactDOM from "react-dom";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Grid,
  Pagination,
  Typography,
  IconButton
} from "@mui/material";
import {alert} from "src/services/alert";
import axios from "axios";
import {IMG_BASE_URL} from "src/config/constants";
import CloseIcon from "@mui/icons-material/Close";
import MyPagination from "./MyPagination";
import imageCompression from "browser-image-compression";

const modalRoot = document.querySelector("#image-picker");

const pageSize = 15;

export const ImagePickerDialog = ({title, multiple, visible, onClose, onSelect}) => {
  const ref = useRef();
  const [pictures, setPictures] = useState([]);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(visible);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  useEffect(() => {
    getImages();
  }, [page]);

  function getImages() {
    let qPage = page
    axios
      .post("/picture/all", {page: qPage, size: pageSize})
      .then((res) => {
        const {code, msg, data, total} = res.data;
        if (code === 1) {
          setPictures(data);
          setTotal(total);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const handleConfirmSelection = () => {
    onSelect(selected.map((s) => s.path).join(","));
    setOpen(false);
  };

  function handlePageChange(event, page) {
    // console.log(page)
    const newPage = page - 1;
    setSelected([]);
    setPage(newPage);
  }

  function handleImgClick(item) {
    const imgs = [...selected];
    const idx = imgs.findIndex((a) => a.id === item.id);
    if (idx === -1) {
      if (imgs.length < 1 || multiple) {
        imgs.push(item);
      } else {
        imgs[0] = item;
      }
    } else {
      imgs.splice(idx, 1);
    }

    setSelected(imgs);
  }

  async function handleUpload(e) {
    if (!e.target.files[0]) return;
    // console.log(e.target.files)

    const formData = new FormData();
    for (let i = 0; i < e.target.files.length; i++) {
      // const imageFile = e.target.files[i];
      // console.log("originalFile instanceof Blob", imageFile instanceof Blob); // true
      // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

      // const options = {
      //   maxSizeMB: 1,
      //   maxWidthOrHeight: 1920,
      //   useWebWorker: true,
      // };
      // try {
      //   const compressedFile = await imageCompression(imageFile, options);
      //   console.log("compressedFile instanceof Blob", compressedFile instanceof Blob); // true
      //   console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

      //   formData.append("images", compressedFile);
      //   // await uploadToServer(compressedFile); // write your own logic
      // } catch (error) {
      //   console.log(error);
      // }

      formData.append("images", e.target.files[i]);
    }

    axios
      .post("/upload/bulk", formData)
      .then((res) => {
        const {code, msg, data} = res.data;
        if (code === 1) {
          ref.current.value = null;
          setPictures([...data, ...pictures].slice(0, pageSize));
          setSelected([]); // 重置
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log(err);
        alert(err?.response?.data?.msg || err.message || "上传失败");
      });
  }

  function handleDelPictures() {
    if (!selected.length) return;

    axios
      .post("/picture/del", {ids: selected.map((s) => s.id)})
      .then((res) => {
        const {code, msg, data} = res.data;
        if (code === 1) {
          getImages();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("删除图片", err);
      });
  }

  function renderImages() {
    // console.log(selected)
    return pictures.map((item, index) => {
      const {id, path} = item;
      const active = selected.findIndex((a) => a.id === id) > -1;

      return (
        <Grid item key={index}>
          <Stack
            key={id}
            sx={{
              cursor: "pointer",
              border: active ? "2px solid #5fb878" : "2px solid transparent",
            }}
            onClick={() => handleImgClick(item)}
          >
            <img
              src={`${IMG_BASE_URL}${path}?w=100`}
              alt={path}
              loading="lazy"
              style={{
                width: 100,
                height: 100,
                objectFit: "contain",
              }}
            />
            {/* <Typography noWrap>{path}</Typography> */}
          </Stack>
        </Grid>
      );
    });
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              // color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon/>
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" my={3}>
          <ButtonGroup>
            <Button disabled={selected.length === 0} onClick={handleConfirmSelection}>
              使用选中图片
            </Button>
            <Button sx={{position: "relative", borderRadius: 0}} component="label" htmlFor="contained-button-file">
              上传图片{" "}
              <input
                ref={ref}
                accept="image/*"
                id="contained-button-file"
                multiple={true}
                type="file"
                onChange={handleUpload}
                style={{
                  position: "absolute",
                  visibility: "hidden",
                }}
              />
            </Button>

            <Button disabled={selected.length === 0} onClick={handleDelPictures}>
              删除图片
            </Button>
          </ButtonGroup>
        </Stack>

        <Grid container spacing={1} columns={5} pb={4}>
          {renderImages()}
        </Grid>

        <MyPagination total={total} page={page} size={pageSize} onChange={handlePageChange}/>
      </DialogContent>
    </Dialog>
  );
};

const ImagePicker = ({
                       title = "请选择需要上传的图片", multiple = false, onSelect = () => {
  }, onClose = () => {
  }
                     }) => {
  ReactDOM.unmountComponentAtNode(modalRoot);
  ReactDOM.render(<ImagePickerDialog visible={true} onClose={onClose} onSelect={onSelect} title={title}
                                     multiple={multiple}/>, modalRoot);
};

export default ImagePicker;
